

define(['angular', 'squid/index', './directive'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-generic-error.route', ['squid', 'hermes.page.xo-generic-error.directive']).factory('$GenericErrorRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GenericErrorRoute', {
      name: 'genericError',
      directive: 'xo-generic-error-page',
      titleContent: 'genericError.pleaseTryAgain',
      query: ['code'],
      // need to find these values
      trackingData: {
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        buzname: {
          'fullpage': {
            'pagename': '%::fullpage-generic-error',
            'pagename2': '%::fullpage-generic-error:member:hermes:',
            'version': 'member:%:'
          }
        }
      },
      children: []
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-error/route.js
// module id = ./pages/xo-generic-error/route.js
// module chunks = 0